import { invenioConfig } from "@config";
import _merge from "lodash/merge";

export const schema = () => {
  const _schema = {
    definitions: {
      payment: {
        properties: {
          debit_cost: {
            $ref: "#/definitions/price",
            title: "Debit amount",
          },
          debit_cost_main_currency: {
            $ref: "#/definitions/price-default-currency",
            title: "Debit amount (main currency)",
          },
          debit_date: {
            format: "date",
            title: "Debit date",
            type: "string",
          },
          debit_note: {
            title: "Debit note",
            type: "string",
          },
          internal_purchase_requisition_id: {
            title: "Internal purchase requisition ID",
            type: "string",
          },
          mode: {
            title: "Payment mode",
            type: "string",
          },
        },
        type: "object",
      },
      "price-default-currency": {
        properties: {
          currency: {
            title: "Currency",
            type: "string",
            enum: ["", invenioConfig.APP.DEFAULT_CURRENCY],
          },
          value: {
            minimum: 0,
            title: "Value",
            type: "number",
          },
        },
        dependencies: {
          value: ["currency"],
          currency: ["value"],
        },
        type: "object",
      },
      price: {
        properties: {
          currency: {
            title: "Currency",
            type: "string",
          },
          value: {
            minimum: 0,
            title: "Value",
            type: "number",
          },
        },
        dependencies: {
          value: ["currency"],
          currency: ["value"],
        },
        type: "object",
      },
    },
    properties: {
      document_pid: {
        title: "Document title",
        type: "string",
      },
      medium: {
        title: "Medium",
        type: "string",
      },
      status: {
        title: "Status",
        type: "string",
        enum: Object.values(invenioConfig.ACQ_ORDERS.statuses)
          .sort((a, b) => a.order - b.order)
          .map((s) => s.value),
      },
      remarks: {
        title: "Remarks",
        type: "string",
      },
      cancel_reason: {
        title: "Cancel reason",
        type: "string",
      },
      patron_pid: {
        title: "Recipient",
        type: "string",
      },
      received_date: {
        format: "date",
        title: "Received date",
        type: "string",
      },
      copies_received: {
        title: "Number of received copies",
        type: ["integer", "null"],
      },
      cost: {
        title: "Cost (PHP)",
        type: ["number", "null"],
        minimum: 0,
        multipleOf: 0.01,
      },
      supplier: {
        title: "Supplier",
        type: ["string", "null"],
      },
      total_cost: {
        title: "Total Cost (PHP)",
        type: ["number", "null"],
        minimum: 0,
        multipleOf: 0.01,
        description: "Cost x No. of Copies or Manual Entry",
      },
      document_details: {
        properties: {},
        type: "object",
        title: "Document details",
      },
      acq_details: {
        properties: {},
        type: "object",
        title: "Acquisition details",
      },
      receiving_details: {
        properties: {},
        type: "object",
        title: "Receiving record",
      },
      expected_delivery_date: {
        format: "date",
        title: "Expected delivery date",
        type: "string",
      },
      funds: {
        items: {
          title: "Description",
          type: "string",
        },
        title: "Funds",
        type: "array",
      },
      grand_total: {
        $ref: "#/definitions/price",
        title: "Order total",
      },
      grand_total_main_currency: {
        $ref: "#/definitions/price-default-currency",
        title: "Order total (main currency)",
      },
      notes: {
        title: "Notes",
        type: "string",
      },
      order_date: {
        format: "date",
        title: "Order date",
        type: "string",
      },
      order_lines: {
        title: "Order lines",
        type: "array",
        default: [],
        items: {
          type: "object",
          properties: {},
        },
      },
      purchase_type: {
        title: "Acquisition Type",
        type: "string",
      },
      payment: {
        $ref: "#/definitions/payment",
        title: "Payment",
      },
    },
    required: ["document_pid", "medium", "status"],
    type: "object",
  };
  return _merge(_schema, invenioConfig.ACQ_ORDERS.editorSchema);
};
